module.exports = __webpack_public_path__ + "img/ES1457.98084199.png";